import { Record } from 'immutable';
import * as ActionTypes from 'automation-ui-action-features/constants/ActionTypes';
import * as EnrollInFlowActionMetadataKeys from 'automation-ui-action-features/actions/enroll-in-flow/constants/EnrollInFlowActionMetadataKeys';
export default class EnrollInFlowActionMetadata extends Record({
  [EnrollInFlowActionMetadataKeys.ACTION_TYPE]: ActionTypes.ENROLL_IN_FLOW,
  [EnrollInFlowActionMetadataKeys.FLOW_ID]: null
}, 'EnrollInFlowActionMetadata') {
  setFlowId(flowId) {
    return this.set(EnrollInFlowActionMetadataKeys.FLOW_ID, flowId);
  }
}